import React from "react";
import { PaymentReleaseRequestStatus } from "../../payments/payment-release-requests/PaymentReleaseRequest.model";
import { PaymentReleaseRequestsForStatus } from "../../payments/payment-release-requests/PaymentReleaseRequestsForStatus";
import { Tab, TabView } from "../common/Tab.view";

export function AdminPaymentReleaseRequestsPageContent() {
  const tabs: Tab[] = Object.values(PaymentReleaseRequestStatus).map(
    (s: PaymentReleaseRequestStatus) => ({
      title: s.replace("_", " "),
      uniqueKey: s,
      content: <PaymentReleaseRequestsForStatus status={s} />,
    })
  );

  const selectedTab = tabs.find(t => t.uniqueKey === PaymentReleaseRequestStatus.WORK_COMPLETED);

  return (
    <div className="AdminPaymentReleaseRequestsPageContent">
      <h3>Payment Release Requests</h3>
      <TabView tabs={tabs} selectedTab={selectedTab} />
    </div>
  );
}
